import { motion } from "framer-motion";
import { Empty, Modal } from "antd";
import { useEffect, useState } from "react";

//STYLE
import { ContainerTalhoes } from "./style";

//APP
import { Item__EquipeCliente } from "../../../../../../services/Equipe/GET";
import { removerAcentos, transition_default } from "../../../../../../utils";
import { Item__Atividades, ItemPropriedades } from "../../../../../../services/atividades/GET";
import { filtarAtividades, filtarAtividadesPorTralhao, obterDetalhesAtvspropriedades, obterDetalhesAtvsTalhoes } from "./meta";

//COMPONENTS
import Input from "../../../../../../Components/CustomUi/input";
import { ModalDetalhesAtvsTalhao } from "./modal/porTalhao";
import { ModalDetalhesAtvsPropriedade } from "./modal/porPropriedade";

//PROPS
interface Props {
    title?: string;
    placeholder?: string;
    dados_talhoes: {
        key: string,
        nome: string,
        cod_filtro: number,
        atividades: any[],
        area_executada: number,
        area_total: number,
        porcentagem: number
    }[];
    data_atividades: Item__Atividades[];
    cod_propriedade?: number;
    cod_talhao?: number;
    data_propriedades: ItemPropriedades[];
    data_equipe_cliente: Item__EquipeCliente[];
}

export const Talhoes: React.FC<Props> = ({ title, placeholder, dados_talhoes, data_atividades, cod_propriedade, cod_talhao, data_propriedades, data_equipe_cliente }) => {

    //STATES
    const [search_talhao, setSearch_talhao] = useState<string>('');
    const [open_modal_propriedades, setOpen_modal_propriedades] = useState(false);
    const [titulo_modal, setTitulo_modal] = useState<string>('');
    const [cod_filtrar_atividade, setCod_filtrar_atividade] = useState<number>(null);
    const [porcentagem_selecionada, setPorcentagem_selecionada] = useState<number>(0);
    const [cod_talhao_selecionado, setCod_talhao_selecionado] = useState<number>(0);

    function encontrarAtivo(buscar_nome: string) {
        const ativoSemAcentos = removerAcentos(buscar_nome)
        return function (item) {
            const nomeSemAcentos = removerAcentos(String(item?.['nome']))
            return nomeSemAcentos.toLowerCase().includes(ativoSemAcentos.toLowerCase()) || !buscar_nome
        }
    }

    return (
        <ContainerTalhoes
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ ...transition_default, delay: 0.4 }}
        >
            <p className="Talhoes__title">{title}</p>

            <Input
                placeholder={placeholder}
                value={search_talhao}
                onChange={setSearch_talhao}
            />

            <div className="Talhoes__list">
                {(dados_talhoes ?? []).filter(encontrarAtivo(search_talhao)).map(({ porcentagem, nome,  key, cod_filtro }) => {
                    return (
                        <motion.button 
                            className="Talhoes__list__item" 
                            key={key} 
                            whileTap={{ scale: 0.98 }} 
                            onClick={()=>{
                                setCod_filtrar_atividade(cod_filtro);
                                setTitulo_modal(nome);
                                setOpen_modal_propriedades(true);
                                setPorcentagem_selecionada(porcentagem);
                                setCod_talhao_selecionado(cod_filtro);
                            }}
                            disabled={!!cod_talhao}
                        >
                            <span className="Talhoes__list__item__name">{nome}</span>

                            <div className="Talhoes__list__item__bar">
                                <div className="Talhoes__list__item__bar__track">
                                    <motion.div
                                        className="Talhoes__list__item__bar__track__progress"
                                        initial={{ width: '0%' }}
                                        animate={{ width: `${Number(porcentagem).toFixed(2)}%` }}
                                        transition={{ ...transition_default, delay: 1 }}
                                        data-overlap={Number(porcentagem) > 100}
                                        data-overlap_150={Number(porcentagem) > 150}
                                        data-overlap_200={Number(porcentagem) > 200}
                                        data-overlap_250={Number(porcentagem) > 250}
                                        data-overlap_300={Number(porcentagem) > 300}
                                    />
                                </div>
                                <AnimatedPercentage value={Number(porcentagem)} />
                            </div>
                        </motion.button>
                    )
                })}

                {dados_talhoes.length === 0 && (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Nenhum registro encontrado" />
                )}
                {(dados_talhoes.length > 0 && (dados_talhoes ?? []).filter(encontrarAtivo(search_talhao)).length === 0) && (
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>'<b>{search_talhao}</b>' não encontrado</>} />
                )}
            </div>

            <Modal
                title={titulo_modal}
                open={open_modal_propriedades}
                onCancel={() => setOpen_modal_propriedades(false)}
                footer={false}
                destroyOnClose
                width={960}
            >
                {cod_propriedade
                    ?
                        <ModalDetalhesAtvsTalhao 
                            detalhes={obterDetalhesAtvsTalhoes(cod_filtrar_atividade, data_atividades)}
                            atividades_filtradas={filtarAtividadesPorTralhao(cod_filtrar_atividade, data_atividades, data_propriedades)}
                            porcentagem_selecionada={porcentagem_selecionada}
                            data_equipe_cliente={data_equipe_cliente}
                            cod_talhao_selecionado={cod_talhao_selecionado}
                        />
                    :
                        <ModalDetalhesAtvsPropriedade 
                            detalhes={obterDetalhesAtvspropriedades(cod_filtrar_atividade, data_atividades)}
                            atividades_filtradas={filtarAtividades(cod_filtrar_atividade, data_atividades, data_propriedades)}
                            porcentagem_selecionada={porcentagem_selecionada}
                            data_equipe_cliente={data_equipe_cliente}
                        />
                }
            </Modal>

        </ContainerTalhoes >
    )
};




interface AnimatedPercentageProps {
    value: number;  // valor final
    speed?: number; // controla a velocidade da animação
    delay?: number; // delay antes de iniciar (ms)
}

export function AnimatedPercentage({ value, speed = 30, delay = 1000 }: AnimatedPercentageProps) {
    const [current, setCurrent] = useState(0);

    useEffect(() => {
        const finalValue = Number(value);
        let interval: NodeJS.Timeout;

        // inicia só depois do delay
        const timeout = setTimeout(() => {
            const increment = finalValue / speed;

            interval = setInterval(() => {
                setCurrent(prev => {
                    const next = prev + increment;
                    return next >= finalValue ? finalValue : next;
                });
            }, 16); // ~60 FPS
        }, delay);

        return () => {
            clearTimeout(timeout);
            clearInterval(interval);
        };
    }, [value, speed, delay]);

    return (
        <div className="Talhoes__list__item__bar__percent">
            {Math.round(current)}%
        </div>
    );
}
